import { render, staticRenderFns } from "./SelectTeatroComponent.vue?vue&type=template&id=b5ec7d4a"
import script from "./SelectTeatroComponent.vue?vue&type=script&lang=js"
export * from "./SelectTeatroComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports